import AppShell from '@/components/AppShell'
import { Link } from 'react-router-dom'

export default function ReportsIndex(){
  return (
    <AppShell title="Reports & Forms">
      <div className="grid gap-3">
        <Quick title="Loads Inbox" to="/loads/inbox" />
        <Quick title="Weighbridge Settings" to="/admin/weighbridge" />
        <Quick title="Settlement Builder" to="/settlements/builder" />
        <Quick title="Profit & Loss" to="/reports/pnl" />

        <ReportCard title="Profit and Loss" desc="Review sales, expenses and profit for jobs and associates (delivered loads, settlements)."/>
        <ReportCard title="Ticket Overview Report" desc="Ticket detail with income and expenses broken down by logging crew."/>
        <ReportCard title="Rates Report" desc="Breakdown of all rates on your jobs."/>
        <ReportCard title="Production Report" desc="Production broken into helpful KPIs."/>
      </div>
    </AppShell>
  )
}

function Quick({title, to}:{title:string; to:string}){
  return (
    <div className="card">
      <div className="card-body flex items-center justify-between">
        <div className="font-semibold">{title}</div>
        <Link className="btn-secondary" to={to}>Open</Link>
      </div>
    </div>
  )
}

function ReportCard({title, desc}:{title:string, desc:string}){
  return (
    <div className="card">
      <div className="card-body flex items-center justify-between">
        <div>
          <div className="font-semibold">{title}</div>
          <div className="text-sm text-slate-600">{desc}</div>
        </div>
        <button className="btn-secondary">Open</button>
      </div>
    </div>
  )
}
